import "@shared-styles/spinner.css";
import { cn } from "@shared-utils/ui";

export const Spinner = () => {
  return (
    <div className={cn("leo-spinner -mt-1", {})}>
      <div className={"dot"}></div>
      <div className={"dot"}></div>
      <div className={"dot"}></div>
      <div className={"dot"}></div>
      <div className={"dot"}></div>
      <div className={"dot"}></div>
      <div className={"dot"}></div>
      <div className={"lead"}></div>
    </div>
  );
};
